module.exports = __webpack_public_path__ + "img/LTS_SAIGA.26487257.gif";